var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "268.5px",
    height: "63.5px",
    viewBox: "0 0 268.5 63.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.395,9.965L38.4,41.101L13.672,16.374l6.009-0.002l14.464,14.466V8.051  c-2.541-0.869-5.265-1.346-8.101-1.346C12.213,6.705,1,17.92,1,31.751c0,9.329,5.105,17.463,12.672,21.772l-0.007-31.149  l24.73,24.732l-6.011-0.002L17.922,32.643v22.799c2.547,0.873,5.279,1.353,8.122,1.353c13.831,0,25.044-11.213,25.044-25.046  C51.088,22.411,45.973,14.272,38.395,9.965"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "62.442,18.784 67.702,18.784 79.855,34.75 79.855,18.784 85.488,18.784 85.488,44.716   80.632,44.716 68.073,28.231 68.073,44.716 62.442,44.716  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88.27,31.824v-0.073c0-7.371,5.817-13.411,13.819-13.411s13.744,5.964,13.744,13.336v0.075  c0,7.373-5.817,13.411-13.819,13.411S88.27,39.198,88.27,31.824 M109.869,31.824v-0.073c0-4.446-3.26-8.15-7.855-8.15  c-4.592,0-7.78,3.629-7.78,8.075v0.075c0,4.446,3.26,8.151,7.855,8.151C106.681,39.902,109.869,36.272,109.869,31.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M119.06,18.784h11.857c3.298,0,5.855,0.926,7.558,2.63c1.447,1.447,2.224,3.485,2.224,5.929v0.075  c0,4.186-2.26,6.817-5.56,8.039l6.337,9.262h-6.672l-5.556-8.301h-4.482v8.301h-5.707V18.784H119.06z M130.547,31.38  c2.779,0,4.37-1.481,4.37-3.667v-0.075c0-2.444-1.703-3.705-4.483-3.705h-5.667v7.447H130.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M144.593,18.786h10.113c8.151,0,13.782,5.594,13.782,12.892v0.073c0,7.3-5.631,12.967-13.782,12.967  h-10.113V18.786z M150.297,23.933v15.635h4.408c4.67,0,7.818-3.15,7.818-7.742v-0.075c0-4.594-3.149-7.818-7.818-7.818H150.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M171.16,31.824v-0.073c0-7.371,5.558-13.411,13.522-13.411c4.892,0,7.818,1.629,10.224,4.002l-3.629,4.186  c-2-1.816-4.038-2.926-6.632-2.926c-4.37,0-7.52,3.629-7.52,8.075v0.075c0,4.446,3.076,8.151,7.52,8.151  c2.965,0,4.779-1.185,6.817-3.037l3.629,3.667c-2.666,2.854-5.631,4.632-10.632,4.632C176.827,45.162,171.16,39.273,171.16,31.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M195.913,31.824v-0.073c0-7.371,5.816-13.411,13.819-13.411c8.002,0,13.744,5.964,13.744,13.336v0.075  c0,7.373-5.816,13.411-13.819,13.411C201.656,45.162,195.913,39.198,195.913,31.824 M217.513,31.824v-0.073  c0-4.446-3.26-8.15-7.855-8.15c-4.592,0-7.78,3.629-7.78,8.075v0.075c0,4.446,3.26,8.151,7.855,8.151  C214.325,39.902,217.513,36.272,217.513,31.824"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "226.52,18.784 232.67,18.784 239.489,29.749 246.304,18.784 252.454,18.784 252.454,44.716   246.785,44.716 246.785,27.787 239.489,38.865 239.34,38.865 232.114,27.896 232.114,44.716 226.52,44.716  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.40b2737f4b448ab6009ab9790e9498da.svg";
export { ForwardRef as ReactComponent };